module.exports = __webpack_public_path__ + "static/media/domain-activated.757ab676.svg";